import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './pdf-viewer.module.scss';

type PdfViewerProps = {
  data: ArrayBuffer;
};

export const PdfViewer = ({ data }: PdfViewerProps) => {
  const { t } = useTranslation();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    setPdfUrl(url);

    return () => {
      URL.revokeObjectURL(url);
      setPdfUrl(null);
    };
  }, [data]);

  if (!pdfUrl) {
    return null;
  }

  return (
    <object data={pdfUrl} type="application/pdf" className={styles.pdfViewer}>
      <p>{t('audit.pdfViewer.unsupported')}</p>
    </object>
  );
};
